import styled, { DefaultTheme } from "styled-components";

export interface IStyles {
    theme: DefaultTheme;
    isGiftcardFlow?: boolean;
}

export const Container = styled.div<IStyles>(({ theme, isGiftcardFlow }) => ({
    width: "100vw",
    height: "100vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
        display: "none !important",
        width: 0,
        height: 0,
    },
    scrollbarWidth: "none",
    "-ms-overflow-style": "none",
    background: isGiftcardFlow
        ? theme.colors[theme.colorMode].background_Primary
        : theme.colors[theme.colorMode].background_Secondary,
}));

export const BodyContainer = styled.div<IStyles>(({ theme, isGiftcardFlow }) => {
    return {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        padding: theme.spacing.medium,
        backgroundColor: isGiftcardFlow
            ? theme.colors[theme.colorMode].background_Primary
            : theme.colors[theme.colorMode].background_Secondary,
        height: isGiftcardFlow ? "fit-content" : "calc(100% - 64px)",
    };
});

/* This is a generic styled version of Container to handle top padding in case of iOS */
export const StyledContainer = styled(Container)`
    @supports (padding-top: var(--sat)) {
        padding-top: var(--sat);
    }
`;
